import { Pipe, PipeTransform } from '@angular/core';
import { VIEW_TYPE } from 'src/app/core/constants/view-type.enum';

@Pipe({
    name: 'requestServiceLevelAgreement'
})
export class RequestServiceLevelAgreementPipe implements PipeTransform {
    transform(row: any, viewType: VIEW_TYPE): any {
        if (row.date && row.date !== 'undefined') {
            const timestamp = row.date.split('T')[0];
            const dateTimeZone = row.date.split('T')[1];
            const dateTime = dateTimeZone.split('.')[0];
            const newDate = timestamp.replace(/-/g, '/');
            row.date = newDate + ' ' + dateTime + ' GMT';
            return this.setSLA(row.date);
        }
        if (row.createdAt && row.createdAt !== 'undefined' && viewType === 'CALL_CENTER_CLIENT_REQUEST') {
            const timestamp = row.createdAt.split('T')[0];
            const dateTimeZone = row.createdAt.split('T')[1];
            const dateTime = dateTimeZone.split('.')[0];
            const newDate = timestamp.replace(/-/g, '/');
            row.createdAt = newDate + ' ' + dateTime + ' GMT';
            return this.setSLA(row.createdAt);
        }
    }
    // transform(row: any, viewType: VIEW_TYPE): any {
    //     if (
    //         [VIEW_TYPE.EMPLOYEE_MANAGEMENT_REQUESTS, VIEW_TYPE.SECURITY_COORDINATOR_REQUESTS].includes(viewType) &&
    //         [ADMISSION_BACKEND_REQUEST_STATUS.COMPLETED, ADMISSION_BACKEND_REQUEST_STATUS.REJECTED, ADMISSION_BACKEND_REQUEST_STATUS.RETURNED].includes(
    //             row.statustxt
    //         )
    //     ) {
    //         return 'bg-oasis-light';
    //     } else {
    //         if (row.date && row.date !== 'undefined') {
    //             const timestamp = row.date.split('T')[0];
    //             const dateTimeZone = row.date.split('T')[1];
    //             const dateTime = dateTimeZone.split('.')[0];
    //             const newDate = timestamp.replace(/-/g, '/');
    //             row.date = newDate + ' ' + dateTime + ' GMT';
    //             return this.setSLA(row.date);
    //         }
    //     }
    // }

    setSLA(time: string) {
        let date = new Date(time),
            diff = (new Date().getTime() - date.getTime()) / 1000,
            daydiff = Math.floor(diff / 86400);

        if (daydiff == -1) {
            daydiff = 0;
        }

        //TODO: handle if creation date is in the future or past
        if (isNaN(daydiff) || daydiff < 0) {
            return '';
        }

        return (
            (daydiff === 0 &&
                ((diff <= 7200 && 'bg-oasis-light') || // 0 - 2 hours passed
                    (diff <= 21600 && 'bg-sunset-light') || // 2 - 6 hours passed
                    (diff > 21600 && 'bg-coral'))) || // over 6 hours passed
            (daydiff > 0 && 'bg-coral') // one day or more have passed
        );
    }
}
